import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { fmtDate } from "../lib/roles";
import { Empty, Loading, PageHeader, Panel } from "../components/common";
import { editLink } from "../lib/settori";

const imgs = (r) => { let l = r.immagini; if (typeof l === "string") { try { l = JSON.parse(l); } catch { l = []; } } return Array.isArray(l) ? l : []; };

export default function MyShiftReports() {
  const [reports, setReports] = useState(null);
  useEffect(() => {
    Promise.all([api("/shift-reports/mine"), api("/web/shift-reports/mine")].map((p) => p.then((d) => d.reports || []).catch(() => [])))
      .then((l) => setReports(l.flat().sort((a, b) => (b.data || "").localeCompare(a.data || ""))));
  }, []);
  if (!reports) return <Loading />;
  return (
    <div>
      <PageHeader subtitle="Report" title="I miei report" />
      {reports.length === 0 ? <Empty title="Nessun report inviato" text="I report che invii compariranno qui." /> : (
        <div className="space-y-3 stagger" data-testid="my-shift-reports">{reports.map((r) => (
          <Link key={r.id} to={editLink(r)} className="block" data-testid={`shift-report-${r.id}`}>
            <Panel className="panel-hover !p-5">
              <div className="flex flex-wrap gap-2 items-center mb-2"><span className="font-semibold text-[var(--navy)]">{fmtDate(r.data)}</span>{r.turno && <span className="tag tag-teal">{r.turno}</span>}{r.settore && <span className="tag tag-slate">{r.settore}</span>}{r.updated_at && <span className="tag tag-amber">Modificato</span>}</div>
              <p className="text-sm text-slate-600"><b>Effettuate:</b> {r.attivita_svolte}</p>
              {r.attivita_da_svolgere && <p className="text-sm text-slate-600 mt-1"><b>Prossimo:</b> {r.attivita_da_svolgere}</p>}
              {imgs(r).length > 0 && <div className="flex gap-2 mt-3">{imgs(r).map((src, i) => <img key={i} src={src} alt="" className="w-16 h-16 rounded-lg object-cover" />)}</div>}
              <p className="text-xs font-semibold text-[var(--teal)] mt-2" data-testid={`shift-report-edit-${r.id}`}>Modifica report</p>
            </Panel>
          </Link>))}
        </div>)}
    </div>
  );
}
